import React from 'react';
import '../../styles/components/pull-out.scss';

export default function PullOut( props ) {

	return (
		<div className={ 'text:pull-out pull-out uppercase' } dangerouslySetInnerHTML={{ __html: props.content.panel }}/>
	);

}